import i18n from "i18next";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  ProgressBar,
} from "@fluentui/react-components";
import { StackShim } from "@fluentui/react-migration-v8-v9";

function DownloadNotification(props: any) {
  return (
    <div>
      <Dialog open={true}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle>
              {i18n.t<string>("preparingDownloadHeader")}
            </DialogTitle>
            <DialogContent>
              <StackShim>
                {i18n.t<string>("preparingDownloadText")}
                <ProgressBar thickness="large" />
              </StackShim>
            </DialogContent>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
}

export default DownloadNotification;
